import React from "react";


import './App.css';
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Calendar from "./components/calendar";
import AttendanceRegister from "./components/AttendanceRegister";
import SaasClientsManagement from "./components/SaasClientsManagement";
import Dashboard from "./components/dashboard";
import Login from "./components/login";
import ManageEmployees from "./components/ManageEmployees";
import HolidayManagement from "./components/HolidayManagement";
import CurrentLeaveList from "./components/CurrentLeaveList";
import HistoryLeaveList from "./components/HistoryLeaveList";
import ProtectedRoute from "./components/ProtectedRoute";
import EmployeeView from "./components/EmployeeView";
import LeaveAddScreen from "./components/LeaveAddScreen";
import EmployeeLeave from "./components/EmployeeLeave";
import MyProfile from "./components/MyProfile";
import WebChecking from "./components/webChecking";
import LeaveType from "./components/LeaveTypeList";
import Department from "./components/DepartmentList";
import DesignationList from "./components/DesignationList";
import GenralSetting from "./components/genralSetting";
import IdentityCardView from "./component/IdentityCardView";

export default function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          {/* Route to login */}
          <Route path="/" element={<Login />} />

          {/* Protected Routes - Only Owner/Pivot and Manager (Role 1, 2) */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute allowedRoles={[1, 2]}>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          {/* Attendance Register - PagarBook / Petpooja Style */}
          <Route
            path="/calendar"
            element={
              <ProtectedRoute allowedRoles={[1, 2]}>
                <AttendanceRegister />
              </ProtectedRoute>
            }
          />
          <Route
            path="/attendance-register"
            element={
              <ProtectedRoute allowedRoles={[1, 2]}>
                <AttendanceRegister />
              </ProtectedRoute>
            }
          />
          {/* Salary & Slips Calculation */}
          <Route
            path="/salary-calculation"
            element={
              <ProtectedRoute allowedRoles={[1, 2]}>
                <Calendar />
              </ProtectedRoute>
            }
          />
          {/* SaaS Client Companies & Machine Licensing - Platform Super Admin (Role 0) */}
          <Route
            path="/saas-clients"
            element={
              <ProtectedRoute allowedRoles={[0]}>
                <SaasClientsManagement />
              </ProtectedRoute>
            }
          />

          <Route
            path="/master/leave"
            element={
              <ProtectedRoute allowedRoles={[1, 2]}>
                <LeaveType />
              </ProtectedRoute>
            }
          />
          <Route
            path="/department"
            element={
              <ProtectedRoute allowedRoles={[1, 2]}>
                <Department />
              </ProtectedRoute>
            }
          />

          <Route
            path="/designation"
            element={
              <ProtectedRoute allowedRoles={[1, 2]}>
                <DesignationList />
              </ProtectedRoute>
            }
          />
          <Route
            path="/genralSetting"
            element={
              <ProtectedRoute allowedRoles={[1, 2]}>
                <GenralSetting />
              </ProtectedRoute>
            }
          />

          <Route
            path="/Web-Checking"
            element={
              <ProtectedRoute allowedRoles={[1, 2, 3]}>
                <WebChecking />
              </ProtectedRoute>
            }
          />
          {/* Employee View - Only for Employees (Role 3) */}
          <Route
            path="/employee-attendance"
            element={
              <ProtectedRoute allowedRoles={[3]}>
                <EmployeeView />
              </ProtectedRoute>
            }
          />

          {/* My Profile - Accessible to all authenticated users (Role 0, 1, 2, 3) */}
          <Route
            path="/my-profile"
            element={
              <ProtectedRoute allowedRoles={[0, 1, 2, 3]}>
                <MyProfile />
              </ProtectedRoute>
            }
          />

          {/* Protected Routes - Only Owner/Pivot and Manager (Role 1, 2) */}
          <Route
            path="/manage-employees"
            element={
              <ProtectedRoute allowedRoles={[1, 2]}>
                <ManageEmployees />
              </ProtectedRoute>
            }
          />


          <Route
            path="/identity-card-format/:userId"
            element={
              <ProtectedRoute allowedRoles={[1, 2]}>
                <IdentityCardView />
              </ProtectedRoute>
            }
          />
          {/* Protected routes- holiday management */}
          <Route
            path="/holiday-management"
            element={
              <ProtectedRoute allowedRoles={[1, 2, 3]}>
                <HolidayManagement />
              </ProtectedRoute>
            }
          />

          {/* Leave Management Routes - All authenticated users (Role 1, 2, 3) */}
          <Route
            path="/leave/current-leave"
            element={
              <ProtectedRoute allowedRoles={[1, 2, 3]}>
                <CurrentLeaveList />
              </ProtectedRoute>
            }
          />

          <Route
            path="/leave/history-leave"
            element={
              <ProtectedRoute allowedRoles={[1, 2, 3]}>
                <HistoryLeaveList />
              </ProtectedRoute>
            }
          />


          <Route
            path="/employee/leave/add"
            element={
              <ProtectedRoute allowedRoles={[1, 2, 3]}>
                <LeaveAddScreen />
              </ProtectedRoute>
            }>


          </Route>
          <Route path="/employee/leave" element={<ProtectedRoute allowedRoles={[3]}>
            <EmployeeLeave />
          </ProtectedRoute>} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

